import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getMachinePriceStatisticsMeta,
  IGetMachinePriceStatisticsMetaParams,
  IGetMachinePriceStatisticsMetaReturn,
  machinePriceStatisticsMetaApiUrl,
} from '../../../../api/marketPrice/queries/getMachinePriceStatisticsMeta';

interface IUseGetMachinePriceStatisticsMetaQueryParams {
  searchParam: IGetMachinePriceStatisticsMetaParams;
  options?: UseQueryOptions<IGetMachinePriceStatisticsMetaReturn, AxiosError>;
}

export const useGetMachinePriceStatisticsMeta = ({
  searchParam,
  options,
}: IUseGetMachinePriceStatisticsMetaQueryParams) => {
  return useQuery<IGetMachinePriceStatisticsMetaReturn, AxiosError>(
    [
      machinePriceStatisticsMetaApiUrl,
      `brand=${searchParam?.brand}`,
      `minEngineOutputPs=${searchParam?.minEngineOutputPs}`,
      `maxEngineOutputPs=${searchParam?.maxEngineOutputPs}`,
      `minMedianPrice=${searchParam?.minMedianPrice}`,
      `maxMedianPrice=${searchParam?.maxMedianPrice}`,
    ],
    () => getMachinePriceStatisticsMeta({ searchParam }),
    options,
  );
};
